import s from './ScanningPageHero.module.scss'
import { FC } from 'react'
import { Container, VideoPlayer } from '@components/ui'
import { CustomImageProps } from '@components/ui/CustomImage/CustomImage'
import { ScanningPage as ScanningPageType } from '@generated/model/models'

type ScanningPageProps = {
  data: ScanningPageType
  children?: any
}

const ScanningPageHero: FC<ScanningPageProps> = ({ data, children }) => {
  return (
    <section className={s.root}>
      <Container>
        {(data.video || data.video_url) && (
          <VideoPlayer
            data={data}
            controls={data.controls || false}
            className={s.videoContainer}
          />
        )}
      </Container>
    </section>
  )
}

export default ScanningPageHero
